export const timezones = [
  { name: 'Hawaii', value: 'Pacific/Honolulu' },
  { name: 'Alaska', value: 'America/Juneau' },
  { name: 'Arizona', value: 'America/Phoenix' },
  { name: 'Pacific Time (US & Canada)', value: 'America/Los_Angeles' },
  { name: 'Mountain Time (US & Canada)', value: 'America/Denver' },
  { name: 'Central Time (US & Canada)', value: 'America/Chicago' },
  { name: 'Eastern Time (US & Canada)', value: 'America/New_York' },
]
